import React, { Component } from 'react';
import PropTypes from 'prop-types';
import HubModel from 'models/hub';
import cx from 'classnames';

import PopularDestinationsCategory from 'components/hub/popular-destinations-category';

const propTypes = {
  hub: PropTypes.instanceOf(HubModel).isRequired,
};

class PopularDestinations extends Component {
  constructor(props) {
    super(props);

    this.renderDestinationCategories = this.renderDestinationCategories.bind(this);
  }

  get cityPerRow() {
    const { hub } = this.props;

    return (hub.isNYC ? 2 : 4);
  }

  renderDestinationCategories(hubCategories) {
    if (!hubCategories) { return null; }
    const { hub } = this.props;

    return (
      hubCategories.valueSeq().map((destinations, index) => {
        const categoryName = destinations.first().category;
        const destinationsCategoryClass = cx({
          'col-md-6': hub.isNYC,
          'col-md-3': !hub.isNYC,
          'col-sm-3': true,
          'col-xs-10': true,
          'col-xs-offset-1': true,
          'col-sm-offset-0': true,
        });
        const destinationMarkup = (
          <div key={`${destinations.first().category}_item`} className={destinationsCategoryClass} >
            <h3 className="h3-sg text-color-dark-slate uppercase bottom">{categoryName}</h3>
            <PopularDestinationsCategory
              hub={hub}
              destinations={destinations}
            />
          </div>
        );

        if ((index + 1) % this.cityPerRow === 0) {
          return (
            <div className="row" key={`${destinations.first().name}_row`}>
              {destinationMarkup}
            </div>
          );
        }
        return destinationMarkup;
      },
      )
    );
  }

  render() {
    const { hub } = this.props;
    const hubCategories = hub && hub.groupPopularDestinationsByCategory;

    return (
      <div>
        {this.renderDestinationCategories(hubCategories)}
      </div>
    );
  }
}

PopularDestinations.propTypes = propTypes;

export default PopularDestinations;
